import { Component, OnInit, Inject } from '@angular/core';
import { Payee } from './shared/sdk/models';
import { PayeeApi } from './shared/sdk/services';
import { GlobalEventsManager } from './events-manager.component';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';
import { ConfirmComponent } from './shared/app/components/confirm.component';
import { ImageModalComponent } from './shared/app/components/image-modal.component';
import { DialogService } from "ng2-bootstrap-modal";
import { LoopBackConfig } from './shared/sdk/index';
import {Idle, DEFAULT_INTERRUPTSOURCES} from '@ng-idle/core';
import {Keepalive} from '@ng-idle/keepalive';
import { DOCUMENT } from '@angular/common';
import { environment } from '../environments/environment';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: [ GlobalEventsManager ]
})

export class AppComponent {

  idleState = 'Not started.';
  timedOut = false;
  lastPing?: Date = null;
  disposable ;
  toPopUp: boolean = false;
  popUpMsg: string;
  hidden = true;

  constructor(
    private idle: Idle, 
    private keepalive: Keepalive,
    private userApi: PayeeApi,
    private eventsManager: GlobalEventsManager,
    private dialogService:DialogService,
    private router: Router,
    @Inject(DOCUMENT) private document: Document
    ) {

      this.eventsManager.showPageEmitter.subscribe(
        res => {
          if (res == false) {
            this.hidden = false;
          } else {
            this.hidden = true;
          }
        }
      )

      this.router.events.subscribe(
        val => {
          if (val instanceof NavigationStart && val.url == '/form') {
            this.hidden = false;
          }
        } 
      );

      this.eventsManager.popUpMsgEmitter.subscribe(
        ([msg,timeout]) => {
          console.log("popUpMsgEmitter msg");
          console.log(msg);
          console.log("popUpMsgEmitter timeout: "+timeout );
          this.popUpMsg = msg;
          this.dialogService.addDialog(ConfirmComponent, {
            title:'Attention', 
            message:msg
          },{
            
            closeByClickingOutside:true,
            autoCloseTimeout: timeout
          })
            .subscribe((isConfirmed)=>{
              console.log("addDialog: isConfirmed ")
              console.log(isConfirmed)
                //We get dialog result
                if(isConfirmed) {
                  // idle.interrupt();
                }
                else {
                  // this.eventsManager.logout();
                  this.dialogService.removeAll();
                }
            });
        }
      );

      this.eventsManager.popUpImageEmitter.subscribe(
        ([img,timeout]) => {
          console.log("popUpImageEmitter img");
          console.log(img);
          console.log("popUpImageEmitter timeout: "+timeout );
          this.popUpMsg = img;
          this.dialogService.addDialog(ImageModalComponent, {
            title:'Attention', 
            message:img
          },{
            
            closeByClickingOutside:true,
            autoCloseTimeout: timeout
          })
            .subscribe((isConfirmed)=>{
              console.log("addDialog: isConfirmed ")
              console.log(isConfirmed)
                //We get dialog result
                if(isConfirmed) {
                  // idle.interrupt();
                }
                else {
                  // this.eventsManager.logout();
                  this.dialogService.removeAll();
                }
            });
        }
      );

      this.eventsManager.showPopUpEmitter.subscribe(
        (popUp) => {
          console.log("showPopUpEmitter popUp")
          console.log(popUp)
            // if (popUp !== null) {
            //   this.toPopUp = popUp;
            // } else {
            //   this.toPopUp = false;
            // }
        }
      );

      // sets an idle timeout of 870 seconds
      idle.setIdle(870);
      // idle.setIdle(5);
      // sets a timeout period of 30 seconds. after 900 seconds of inactivity, the user will be considered timed out.
      idle.setTimeout(30);
      // idle.setTimeout(3);
      // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
      idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

      idle.onIdleEnd.subscribe(() => {
        this.idleState = 'No longer idle.';
        if (this.disposable) {
          this.disposable.unsubscribe();
        }
        
        console.log(this.idleState);
      });

      idle.onTimeout.subscribe(() => {
        this.idleState = 'Timed out!';
        console.log(this.idleState);
        this.timedOut = true;
        this.eventsManager.logout(true);
        this.reset();
      });
      idle.onIdleStart.subscribe(async () => {
        this.idleState = 'You\'ve gone idle!';
        console.log(this.idleState);
        if (this.userApi.isAuthenticated()) {
          let date = new Date();

          this.disposable = this.dialogService.addDialog(ConfirmComponent, {
            title:'Attention', 
            message:"Warning: Your session will expire in 30 seconds starting from " + date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds() + "."
          },{
            autoCloseTimeout:3000,
            closeByClickingOutside:true
          })
            .subscribe((isConfirmed)=>{
                //We get dialog result
                if(isConfirmed) {
                  idle.interrupt();
                }
                else {
                  this.eventsManager.logout();
                  this.reset();
                }
            });
        }
       });


      idle.onTimeoutWarning.subscribe(
        (countdown) => this.idleState = 'You will time out in ' + countdown + ' seconds!'
      );

      
      keepalive.start();
    
      // Set ping interval to how often you want the accessToken to be 'refreshed'
      keepalive.interval(10);
      // replace countAccessTokens() with what you need to call to 'refresh' the accessToken life
      keepalive.onPing.subscribe(() => {
        if (this.userApi.isAuthenticated()) {
          // console.log("ping");
          this.userApi.getCurrent().subscribe(
            (user: Payee) => console.log("ping-"+user.first_name),
            err => {
              console.log(err);
              this.eventsManager.logout(true);
              this.eventsManager.showPopUp("Your session has expired. Please login.");
              this.eventsManager.loaded(true);
            }
          );
        }
      });
      


      this.reset();
    }

  ngOnInit() {
     // console.log(this.document.location.hostname);
   this.router.events.subscribe((evt) => {
        if (!(evt instanceof NavigationEnd)) {
            return;
        }
        //always scroll top when navigate change
        // window.scrollTo(0, 0)
    });
    if (!environment.production) {

     //production code
     
      LoopBackConfig.setBaseURL('https://m2upay.maybank2u.com.my');
      if (this.document.location.hostname == "172.31.99.77") {
        LoopBackConfig.setBaseURL('https://172.31.99.77:8443');
      }

     //local code
      //LoopBackConfig.setBaseURL('http://localhost:3001');
    }
    else if (environment.production) {
      LoopBackConfig.setBaseURL('https://m2upay.maybank2u.com.my');
      if (this.document.location.hostname == "202.162.18.55") {
        LoopBackConfig.setBaseURL('https://202.162.18.55');
      }
    }
  }

  reset() {
    this.idle.watch();
    this.idleState = 'Started.';
    this.timedOut = false;
  }

}
